import { regex } from "vuelidate/lib/validators/common";
import { email } from "vuelidate/lib/validators";

/**
 * Custom validator to know if a given string separated with a delimiter is a valid Email List
 * Closure
 * @param {*} delimiter The character delimiter for the given list
 * @returns {function} Returns a function which receives a string to evaluate if it's a email list
 */
const emailList = (delimiter = ",") => {
  return function (param) {
    if (param.trim().length <= 0) return true;

    if (
      param
        .replace(/\s/g, "")
        .split(";")
        .filter((value) => value.length == 0).length > 0
    )
      return false;

    return param
      .split(`${delimiter}`)
      .map((value) => value.trim())
      .filter((value) => value.length > 0)
      .every(email);
  };
};

const isBooleanValue =
  (expect = true) =>
    (param) =>
      param == expect;

const alphaNumDot = regex("alpha", /^[a-zA-Z0-9.]+$/);
const alphaNumDotUnderscore = regex("alpha", /^[a-zA-Z0-9._]+$/);

export { emailList, isBooleanValue, alphaNumDot, alphaNumDotUnderscore };

export default {
  data() {
    return {
      emailList
      , isBooleanValue
      , alphaNumDot
      , alphaNumDotUnderscore
    };
  }
};



// WEBPACK FOOTER //
// ./src/helpers/vuelidate/validators.js